import { useQuery } from "@tanstack/react-query"

import { getDiagnosticos } from "../services/consulta.service";

export const usePacienteConsultaDiagnosticos = () => {

    const pacienteConsultaDiagnosticosQuery = useQuery({
        queryKey: ['paciente/consulta/diagnosticos'],
        queryFn: () => getDiagnosticos(),
        staleTime: 8 * 60 * 60 * 1000, // 5 horas
    });

    return {
        pacienteConsultaDiagnosticosQuery,
    }
}